import { render, staticRenderFns } from "./UserDetailing.vue?vue&type=template&id=387c8928&scoped=true&"
import script from "./UserDetailing.vue?vue&type=script&lang=ts&"
export * from "./UserDetailing.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailing.vue?vue&type=style&index=0&id=387c8928&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c8928",
  null
  
)

export default component.exports